import pushModel from "../../mixin/store/api/pushModel";

export default {
    actions: {
        pushPayme(context, planName) {
            let data = {}
            data.planName = planName

            return pushModel(context, 'payme_transactions', data, 'updatePayme')
        },
    },
    mutations: {
        updatePayme(state, data) {
            state.payme = data
        }
    },
    state: {
        payme: {
        },
    },
    getters: {
        getPayme(state) {
            return state.payme
        },
    },
}
